// @ticket TM-1000001714
// Wire-format compatible with backend `com.mvs.backend.core.dto.DeletionTypeEnum`
// (Jackson default by-name serialization → string values match backend `name()`).
//
// Pattern: discriminated string-literal type + companion const — avoids the TS `enum` keyword
// (per project ENUM1 rule "implicit values only") while preserving the literal string wire format.

export type DeletionType = 'SOFT' | 'HARD';

export const DeletionType = {
    SOFT: 'SOFT' as const,
    HARD: 'HARD' as const,
};
